"use client";

import { useTranslation } from "@/lib/i18n";
import { TResume } from "@/lib/store/resume";
import { formatPostalCodeWithPadding } from "@/utils";
import classNames from "classnames";
import { ReactNode } from "react";
import { TemplateProps } from ".";
import { Picture } from "../sidebars/left/sections/shared/Picture";

const TDCellContent = (props: {
  label: ReactNode | string;
  value?: string;
  valueClassNames?: string;
}) => {
  const { label, value, valueClassNames } = props;
  return (
    <div className="relative flex h-full w-full flex-col  items-center">
      <div className="mb-[20px] h-[14px] w-full text-sm">{label}</div>
      <div
        className={classNames(
          "flex items-start overflow-hidden text-sm",
          valueClassNames,
        )}
      >
        {value}
      </div>
    </div>
  );
};

const Header = ({ resume }: { resume: TResume }) => {
  const { t } = useTranslation({ ns: "resume-sidebar" });

  const basics = resume.data.basics;

  if (!basics) return null;

  return (
    <div className="relative w-full">
      <div className="mb-2 flex w-[440px] items-end justify-between">
        <p className="space-x-4 text-3xl">
          <span>履</span>
          <span>歴</span>
          <span>書</span>
        </p>
        <p className="text-base">{basics.creationDate}</p>
      </div>
      <table
        className="w-full table-fixed"
        style={{
          borderLeft: "2px solid black",
          borderBottom: "2px solid black",
        }}
      >
        <tbody>
          <tr>
            <td
              colSpan={2}
              className="h-[10px] w-[450px] text-sm"
              style={{
                borderBottom: "1px dashed black",
                borderRight: "2px solid black",
                borderTop: "2px solid black",
              }}
            >
              <div className="relative flex h-full items-center">
                <div className="relative flex h-full items-center">
                  <span className="block h-full w-[80px]">ふりがな</span>
                  <span className="block h-full w-[360px] overflow-hidden whitespace-nowrap text-center">
                    {basics.furigana}
                  </span>
                </div>
              </div>
            </td>
            <td className="!border-none"></td>
          </tr>
          <tr>
            <td
              colSpan={2}
              className="h-[80px] w-[450px]"
              style={{
                borderTop: "1px dashed black",
                borderRight: "2px solid black",
              }}
            >
              <div className="relative flex h-[80px] w-full items-center">
                <div className="flex h-[80px] w-[40px] items-center text-sm">
                  名前
                </div>
                <div className="flex h-[80px] flex-1 items-center justify-center overflow-hidden !text-2xl font-semibold">
                  {basics.name}
                </div>
              </div>
            </td>
            <td className="!border-none"></td>
          </tr>
          <tr>
            <td
              colSpan={2}
              className="h-[60px] !p-0 text-center text-lg"
              style={{
                borderRight: "2px solid black",
              }}
            >
              <div className="flex h-[60px] w-full ">
                <div
                  className="flex h-[60px] w-[400px] items-center justify-end overflow-hidden whitespace-nowrap text-sm"
                  style={{
                    padding: "5px",
                  }}
                >
                  {basics.birthdate}
                </div>
                <div
                  className="flex h-[60px] w-full flex-1 items-center justify-center"
                  style={{
                    padding: "5px",
                    borderLeft: "1px solid rgb(15 23 42)",
                  }}
                >
                  <div
                    className={classNames(
                      "flex h-[26px] w-[26px] items-center justify-center rounded-full text-sm",
                      basics.gender === "男" ? " border border-black" : "",
                    )}
                  >
                    男
                  </div>
                  <div className="text-2xl">·</div>
                  <div
                    className={classNames(
                      "flex h-[26px] w-[26px] items-center justify-center rounded-full text-sm",
                      basics.gender === "女" ? " border border-black" : "",
                    )}
                  >
                    女
                  </div>
                </div>
              </div>
            </td>
            <td className="!border-none"></td>
          </tr>
          {/* <tr>
            <td colSpan={2} className="h-[40px] w-[600px]">
              <TDCellContent label="Email" value={basics.email} />
            </td>
            <td className="h-[40px]">
              <TDCellContent label="電話" value={basics.phone} />
            </td>
          </tr> */}
          <tr
            style={{
              borderRight: "2px solid black",
            }}
          >
            <td
              colSpan={2}
              className="h-[10px] w-full text-sm"
              style={{
                borderBottom: "1px dashed black",
                borderTop: "2px solid black",
              }}
            >
              <div className="relative flex h-full items-center">
                <span className="block h-full w-[80px]">ふりがな</span>
                <span className="block h-full flex-1 overflow-hidden whitespace-nowrap text-center">
                  {basics.locationFurigana}
                </span>
              </div>
            </td>
            <td
              colSpan={1}
              className="h-[10px] w-full text-sm"
              style={{
                borderTop: "2px solid black",
              }}
            >
              <div className="relative flex h-full items-center">
                <span className="block h-full w-[60px] ">電話</span>
                <span className="block h-full flex-1 overflow-hidden whitespace-nowrap text-center">
                  {basics.phone}
                </span>
              </div>
            </td>
          </tr>
          <tr
            style={{
              borderRight: "2px solid black",
            }}
          >
            <td
              colSpan={2}
              className="h-[70px] w-full"
              style={{ borderTop: "1px dashed black" }}
            >
              <TDCellContent
                label={
                  <div className="flex items-center justify-between text-sm">
                    <div className="space-x-7">
                      <span>現住所</span>
                      <span>
                        〒 {formatPostalCodeWithPadding(basics.postalCode)}
                      </span>
                    </div>
                  </div>
                }
                value={basics.location}
                valueClassNames="h-[44px]"
              />
            </td>
            <td colSpan={1} className="h-[70px] ">
              <TDCellContent
                label="Email"
                value={basics.email}
                valueClassNames="h-[44px]"
              />
            </td>
          </tr>
          <tr
            style={{
              borderRight: "2px solid black",
            }}
          >
            <td
              colSpan={2}
              className="h-[10px] w-full text-sm"
              style={{ borderBottom: "1px dashed black" }}
            >
              <div className="relative flex h-full items-center">
                <span className="block h-full w-[80px]">ふりがな</span>
                <span className="block h-full flex-1 overflow-hidden whitespace-nowrap text-center">
                  {basics.contactLocationFurigana}
                </span>
              </div>
            </td>
            <td colSpan={1} className="h-[10px] w-full text-sm">
              <div className="relative flex h-full items-center">
                <span className="block h-full w-[60px] ">電話</span>
                <span className="block h-full flex-1 overflow-hidden whitespace-nowrap text-center">
                  {basics.phone}
                </span>
              </div>
            </td>
          </tr>
          <tr
            style={{
              borderRight: "2px solid black",
            }}
          >
            <td
              colSpan={2}
              className="h-[70px] w-full"
              style={{ borderTop: "1px dashed black" }}
            >
              <TDCellContent
                label={
                  <div className="flex items-center justify-between text-sm">
                    <div className="space-x-7">
                      <span>連絡先</span>
                      <span>
                        〒
                        {formatPostalCodeWithPadding(
                          basics.contactLocationPostalCode,
                        )}
                      </span>
                    </div>
                    <span>(現住所以外に連絡を希望する場合のみ入力)</span>
                  </div>
                }
                value={basics.contactLocation}
                valueClassNames="h-[44px]"
              />
            </td>
            <td colSpan={1} className="h-[70px] ">
              <TDCellContent
                label="Email"
                value={basics.email}
                valueClassNames="h-[44px]"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <Picture
        resume={resume}
        className="!absolute right-[72px] top-[30px] h-[168px] w-[120px]"
      />
    </div>
  );
};

const EducationAndExperience1 = ({ resume }: { resume: TResume }) => {
  const section = resume.data.sections?.educationAndExperience;
  const items = section?.items || [];
  return (
    <table
      className="w-full table-fixed"
      style={{
        border: "2px solid black",
      }}
    >
      <tbody>
        <tr className="h-[26px]">
          <td
            className="text-md w-[100px] py-0 text-center"
            style={{ borderRight: "1px dashed black" }}
          >
            年
          </td>
          <td
            className="text-md w-[40px] py-0 text-center"
            style={{ borderLeft: "1px dashed black" }}
          >
            月
          </td>
          <td className="text-md py-0 text-center">学歴·職歴</td>
        </tr>
        {Array(16)
          .fill("")
          .map((_, i) => i)
          .map((res, i) => {
            return (
              <tr key={res} className="h-[34px]">
                <td
                  className="text-md w-[60px] overflow-hidden whitespace-nowrap text-center"
                  style={{ borderRight: "1px dashed black" }}
                >
                  {items[res]?.year || ""}
                </td>
                <td
                  className=" text-md w-[40px] overflow-hidden whitespace-nowrap text-center"
                  style={{ borderLeft: "1px dashed black" }}
                >
                  {items[res]?.month || ""}
                </td>
                <td className=" text-md overflow-hidden whitespace-nowrap text-center">
                  {items[res]?.summary || ""}
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

const EducationAndExperience2 = ({ resume }: { resume: TResume }) => {
  const section = resume.data.sections?.educationAndExperience;
  const items = section?.items || [];
  return (
    <table
      className="w-full table-fixed"
      style={{
        border: "2px solid black",
      }}
    >
      <tbody>
        <tr className="h-[26px]">
          <td
            className="text-md w-[100px] py-0 text-center"
            style={{ borderRight: "1px dashed black" }}
          >
            年
          </td>
          <td
            className="text-md w-[40px] py-0 text-center"
            style={{ borderLeft: "1px dashed black" }}
          >
            月
          </td>
          <td className="text-md py-0 text-center">学歴 · 職歴</td>
        </tr>
        {Array(6)
          .fill("")
          .map((_, i) => i + 16)
          .map((res, i) => {
            return (
              <tr key={res} className="h-[34px]">
                <td
                  className="text-md w-[60px] overflow-hidden whitespace-nowrap text-center"
                  style={{ borderRight: "1px dashed black" }}
                >
                  {items[res]?.year || ""}
                </td>
                <td
                  className=" text-md w-[40px] overflow-hidden whitespace-nowrap text-center"
                  style={{ borderLeft: "1px dashed black" }}
                >
                  {items[res]?.month || ""}
                </td>
                <td className=" text-md overflow-hidden whitespace-nowrap text-center">
                  {items[res]?.summary || ""}
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

const Certifications = ({ resume }: { resume: TResume }) => {
  const section = resume.data.sections?.certifications;
  const items = section?.items || [];
  return (
    <table
      className="w-full table-fixed"
      style={{
        border: "2px solid black",
      }}
    >
      <tbody>
        <tr className="h-[26px]">
          <td
            className="text-md w-[100px] py-0 text-center"
            style={{ borderRight: "1px dashed black" }}
          >
            年
          </td>
          <td
            className="text-md w-[40px] py-0 text-center"
            style={{ borderLeft: "1px dashed black" }}
          >
            月
          </td>
          <td className="text-md py-0 text-center">免許・資格</td>
        </tr>
        {Array(6)
          .fill("")
          .map((_, i) => i)
          .map((res, i) => {
            return (
              <tr key={res} className="h-[34px]">
                <td
                  className=" text-md w-[60px] overflow-hidden whitespace-nowrap text-center"
                  style={{ borderRight: "1px dashed black" }}
                >
                  {items[res]?.year || ""}
                </td>
                <td
                  className=" text-md w-[40px] overflow-hidden whitespace-nowrap text-center"
                  style={{ borderLeft: "1px dashed black" }}
                >
                  {items[res]?.month || ""}
                </td>
                <td className=" text-md overflow-hidden whitespace-nowrap text-center">
                  {items[res]?.summary || ""}
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

const AmbitionMotive = ({ resume }: { resume: TResume }) => {
  const section = resume.data.sections?.ambitionMotive;
  const basics = resume.data.basics;
  return (
    <table
      className="h-[250px] w-full table-fixed"
      style={{
        border: "2px solid black",
      }}
    >
      <tbody>
        <tr>
          <td rowSpan={3} className="w-[380px]" colSpan={1}>
            <div className="text-md mb-1 h-[20px]">
              志望動機・特技・アピールポイントなど
            </div>
            <div
              className="h-[210px] overflow-hidden text-base"
              dangerouslySetInnerHTML={{ __html: section?.content || "" }}
            />
          </td>
          <td
            className="relative h-[90px]"
            colSpan={2}
            style={{
              padding: "5px",
            }}
          >
            <div className="text-md absolute left-1 top-1">通勤時間</div>
            <div className="flex items-center justify-end overflow-hidden whitespace-nowrap text-sm">
              {basics?.commuteTime || ""}
            </div>
          </td>
        </tr>
        <tr>
          <td
            className="relative h-[90px]"
            colSpan={2}
            style={{
              padding: "5px",
            }}
          >
            <div className="text-md absolute left-1 top-1">
              扶養家族数（配偶者を除く）
            </div>
            <div className="flex items-center justify-end overflow-hidden whitespace-nowrap text-sm">
              {basics?.dependents || ""}
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div className="text-md mb-1 h-[20px]">配偶者</div>
            <div className="flex items-center justify-start space-x-1">
              <div
                className={classNames(
                  "flex h-[26px] w-[26px] items-center justify-center rounded-full text-sm",
                  basics?.hasSpouse === "true" ? " border border-black" : "",
                )}
              >
                有
              </div>
              <div className="text-2xl">·</div>
              <div
                className={classNames(
                  "flex h-[26px] w-[26px] items-center justify-center rounded-full text-sm",
                  basics?.hasSpouse === "false" ? " border border-black" : "",
                )}
              >
                無
              </div>
            </div>
          </td>
          <td>
            <div className="text-md mb-1 h-[20px]">配偶者の扶養義務</div>
            <div className="flex items-center justify-start space-x-1">
              <div
                className={classNames(
                  "flex h-[26px] w-[26px] items-center justify-center rounded-full text-sm",
                  basics?.hasSpousalSupportDuty === "true"
                    ? " border border-black"
                    : "",
                )}
              >
                有
              </div>
              <div className="text-2xl">·</div>
              <div
                className={classNames(
                  "flex h-[26px] w-[26px] items-center justify-center rounded-full text-sm",
                  basics?.hasSpousalSupportDuty === "false"
                    ? " border border-black"
                    : "",
                )}
              >
                無
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

const Expectations = ({ resume }: { resume: TResume }) => {
  const section = resume.data.sections?.expectations;
  return (
    <table
      className="h-[250px] w-full table-fixed"
      style={{
        border: "2px solid black",
      }}
    >
      <tbody>
        <tr>
          <td rowSpan={3}>
            <div className="text-md mb-1 h-[20px]">
              本人希望欄（特に給料・職種・勤務時間・勤務地・その他について希望があれは記入）
            </div>
            <div
              className="h-[210px] overflow-hidden text-base"
              dangerouslySetInnerHTML={{ __html: section?.content || "" }}
            />
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export const JIS = ({
  resume,
  columns,
  isFirstPage = false,
}: TemplateProps) => {
  const [main, sidebar] = columns;

  return (
    <div className="space-y-4 p-[38px]">
      <Header resume={resume} />
      <EducationAndExperience1 resume={resume} />
      <EducationAndExperience2 resume={resume} />
      <Certifications resume={resume} />
      <AmbitionMotive resume={resume} />
      <Expectations resume={resume} />
    </div>
  );
};
